import { isProd, getEnv } from "utils/env";
import {
  getRemoteConfig,
  getValue,
  fetchAndActivate,
} from "firebase/remote-config";
import { initializeApp } from "firebase/app";
import {
  WEB_AUTHN_FLAG,
  CHANGE_NECTAR_ACCOUNT_FLAG,
  SSO_FLAG,
} from "./featureFlagKeys";

const firebaseConfig = {
  apiKey: getEnv("REACT_APP_FIREBASE_API_KEY"),
  authDomain: getEnv("REACT_APP_FIREBASE_AUTH_DOMAIN"),
  projectId: getEnv("REACT_APP_FIREBASE_PROJECT_ID"),
  messagingSenderId: getEnv("REACT_APP_FIREBASE_MESSAGING_SENDER_ID"),
  appId: getEnv("REACT_APP_FIREBASE_APP_ID"),
};

initializeApp(firebaseConfig);

const remoteConfig = getRemoteConfig();

remoteConfig.defaultConfig = {
  [WEB_AUTHN_FLAG]: isProd() ? "false" : "true",
  [CHANGE_NECTAR_ACCOUNT_FLAG]: "false",
  [SSO_FLAG]: isProd() ? "false" : "true",
};

let flags = [];

export const getRemoteFlags = async () => {
  await fetchAndActivate(remoteConfig).then(() => {
    flags = [
      [
        CHANGE_NECTAR_ACCOUNT_FLAG,
        getValue(remoteConfig, CHANGE_NECTAR_ACCOUNT_FLAG).asString(),
      ],
      [WEB_AUTHN_FLAG, getValue(remoteConfig, WEB_AUTHN_FLAG).asString()],
      [SSO_FLAG, getValue(remoteConfig, SSO_FLAG).asString()],
    ];
  });
  return flags;
};
